import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { register } from 'swiper/element/bundle';

@Component({
  selector: 'app-customer-reviews',
  imports: [CommonModule, CarouselModule],
  templateUrl: './customer-reviews.component.html',
  styleUrl: './customer-reviews.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CustomerReviewsComponent {
  constructor() {
    register();
  }
feedbacks = [
  {
    text: "I recently hit a 5,000 token milestone and unlocking my next reward tier was incredibly smooth. Everything was handled professionally. This platform feels secure and is easily my top trustworthy online gaming hub.",
    name: "Jay G.",
    role: "Elite Arcade Player",
    img: "https://cmax.pages.dev/assets/landing-page/reviews/client1.jpg"
  },
  {
    text: "This is my absolute favorite online gaming hub! The daily token offers are generous, support is active 24/7, and the games run without lag. I play regularly and highly recommend it.",
    name: "Ryan V.",
    role: "Elite Arcade Player",
    img: "https://cmax.pages.dev/assets/landing-page/reviews/client2.jpg"
  },
  {
    text: "After trying multiple sites, this became my top pick. The game variety is excellent on mobile and support verified my profile in minutes. My first achievement tier unlocked instantly.",
    name: "Daniel T.",
    role: "Elite Arcade Player",
    img: "https://cmax.pages.dev/assets/landing-page/reviews/client3.jpg"
  },
  {
    text: "I'm really impressed after playing for a few months. They offer a huge selection of interactive challenges. The welcome token bundle gave me a great start, and gameplay is consistently smooth.",
    name: "Michael R.",
    role: "Elite Arcade Player",
    img: "https://cmax.pages.dev/assets/landing-page/reviews/client4.jpg"
  }
];


  currentSlide = 1;
  totalSlides = 3;

  previousSlide(): void {
    this.currentSlide = this.currentSlide === 0 ? this.totalSlides - 1 : this.currentSlide - 1;
  }

  nextSlide(): void {
    this.currentSlide = this.currentSlide === this.totalSlides - 1 ? 0 : this.currentSlide + 1;
  }

  goToSlide(index: number): void {
    this.currentSlide = index;
  }

  getDots(): number[] {
    return Array(this.totalSlides).fill(0).map((_, i) => i);
  }
}
